import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginProvider, useAuth } from './context/Login.context';
import {Portal, Login, Profile, Register, VerifyEmail, PaymentSuccess, PaymentFailure, PaymentPending, Pricing} from './view';

// Componente para rutas protegidas
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuth, loading } = useAuth();

  if (loading) {
    // Puedes mostrar un spinner o un componente de carga aquí
    return null; 
  }

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<Portal />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/payments/success" element={<PaymentSuccess />} />
      <Route path="/payments/failure" element={<PaymentFailure />} />
      <Route path="/payments/pending" element={<PaymentPending />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      {/* Puedes añadir más rutas aquí si es necesario */}
    </Routes>
  );
}

function App() {
  return (
    <Router basename="/">
      <LoginProvider>
        <AppContent />
      </LoginProvider>
    </Router>
  );
}

export default App;
